var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-gis-editor"},[_c('div',{style:(_vm.minHeight),attrs:{"id":_vm.nameMap}})])
}
var staticRenderFns = []

export { render, staticRenderFns }